<div class="clear"></div>
<div [ngClass]="">
  <div class="widget-container">
    <h3 class="group-title">
      Use of third party data and default responses disclosure
    </h3>    
    
    <div>

      <div>      
        <div class="fraud-disclosures">
          
          <div class="text-info">
            <p class="text">To simplify your quoting journey, we collected third-party data about your customer to create this quote; utilized information presented by your customer on their website (when website address was provided; and defaulted standard coverages and/or limits. By issuing this quote, you confirm that you have reviewed and updated any incorrect information about your customer that was presented in the quoting experience and on the quote proposal. You also confirm your customer's information is true and correct to the best of knowledge.</p>
          </div>

        </div>
      </div>
      
    </div>
  </div>
</div>
<div class="clear"></div>
